import { render } from "./massSms.vue?vue&type=template&id=8dab9642"
import script from "./massSms.vue?vue&type=script&lang=js"
export * from "./massSms.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nice-life-contract/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__